import { createContext, useContext } from "react";

// Public, anonymous data only. The same snapshot is used during the build and
// the first browser render; live requests can refresh it after hydration.
export const PublicPageData = createContext({});
export const usePublicPageData = () => useContext(PublicPageData);
